<template>
  <v-container class="d-flex flex-column ga-3">
    <UsageExample v-model="tab" :code="code" :tabs="tabs">
      <HxSearch v-model:search="searchText" :placeholder="placeholder" />
    </UsageExample>
  </v-container>
</template>

<script>
import UsageExample from '@/components/helix/utils/UsageExample';

export default {
  name: 'HelixSearch',
  components: { UsageExample },
  setup() {
    const code = `
<hx-search v-model:search="searchText" :placeholder="'Search here...'"/>
    `;
    return {
      code
    };
  },
  data() {
    return {
      tab: 'Search Usage',
      tabs: ['Search Usage'],
      searchText: '',
      placeholder: 'Search here...'
    };
  },
  watch: {
    searchText(newValue) {
      console.log('Search text updated:', newValue);
    }
  }
};
</script>
